import React from 'react';
import styles from './TraneTextBubbleBanners.module.css';
import { Row, Col } from 'reactstrap';
import OpportunityBanner from '../../assets/images/Vendor/Trane/TraneOpportunitiesStockBanner.jpeg';
import BenefitsBanner from '../../assets/images/Vendor/Trane/TraneBenefitsBannerStock.jpeg';

const TraneTextBubbleBanners = () => {
    return (
        <Row className={styles.getStartedContainer}>
            <Col
                className={styles.opportunityImageContainer}
                md='12'
                lg='6'
            >
                <img
                    src={OpportunityBanner}
                    alt='Opportunities Banner'
                />
                <div className={styles.bannerBubble}>
                    <h6>MORE INCOME</h6>
                    <h3>Opportunities for You</h3>
                    <p>
                        Adding an ESA can help increase your average sale price and ensure prompt payment for service
                        calls while building trust, relationships and referrals through positive customer experiences.
                    </p>
                </div>
            </Col>
            <Col
                className={styles.benefitsImageContainer}
                md='12'
                lg='6'
            >
                <img
                    src={BenefitsBanner}
                    alt='Benefits Banner'
                />
                <div className={styles.bannerBubble}>
                    <h6>MORE SATISFACTION</h6>
                    <h3>Benefits for Customers</h3>
                    <p>
                        ComfortSure ESAs allow your customers to get professionally-serviced equipment by the installing
                        dealer they trust - you, without the financial burden of labor repair costs.
                    </p>
                </div>
            </Col>
        </Row>
    );
};

export default TraneTextBubbleBanners;
